import React, {useState} from 'react';
import styled from 'styled-components';
import {Handle, Position, NodeToolbar} from '@xyflow/react';

const FlowchartStep = ({data, id}) => {
	const [visibility, setVisibility] = useState(false);

	const toggleVisibility = () => {
		setVisibility(!visibility);
	};
	return (
		<FlowchartStepNodeDiv>
			<NodeToolbar isVisible={visibility}>
				<button
					style={{fontSize: '10px', border: '1px solid lightgrey', borderRadius: '5px'}}
					onClick={() => {
						data.onDeleteClick(id);
					}}
				>
					delete
				</button>
			</NodeToolbar>
			<Handle type="target" position={Position.Top} id="1" />
			<Handle type="source" position={Position.Bottom} id="2" />
			<Handle type="target" position={Position.Left} id="3" />
			<Handle type="source" position={Position.Right} id="4" />
			{/* <span style={{float:'right'}}> */}
			<button
				style={{
					fontWeight: 'bold',
					fontSize: '18px',
					border: '1px solid lightgrey',
					backgroundColor: 'lightgrey',
					borderRadius: '100%',
					float: 'right'
				}}
				onClick={toggleVisibility}
			>
				···
			</button>
			{/* </span> */}
			<p className="title">{data.title}</p>
			<p className="description">{data.description}</p>
			<div className="buttonContainer">
				<button className="cancelButton" onClick={data.onCancelClick}>
					Cancel
				</button>
				<button className="saveButton" onClick={data.onSaveClick}>
					Save
				</button>
			</div>
		</FlowchartStepNodeDiv>
	);
};

export default FlowchartStep;

const FlowchartStepNodeDiv = styled.div`
	position: relative;
	width: 200px;
	height: 150px;
	padding: 10px;
	background-color: #fff;
	border: 1px solid rgba(230, 230, 233, 1);
	box-shadow: 0px 6px 12px 0px rgba(35, 35, 47, 0.08);

	.title {
		font-weight: 400;
		font-size: 12px;
		color: rgba(77, 77, 92, 1);
	}

	.description {
		font-weight: 300;
		font-size: 10px;
		color: rgba(46, 46, 56, 1);
	}

	.buttonContainer {
		position: absolute;
		right: 0;
		bottom: 0;
		margin: 5px;
		display: flex;
		justify-content: space-around;
		align-items: center;
	}

	.saveButton {
		background-color: #000;
		margin: 5px;
		color: #fff;
		border-radius: 10px;
		height: 20px;
		width: 40px;
		border: none;
		cursor: pointer;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.cancelButton {
		background-color: #fff;
		margin: 5px;
		color: #000;
		border-radius: 10px;
		border: 1px solid #000;
		height: 20px;
		width: 40px;
		cursor: pointer;
		display: flex;
		justify-content: center;
		align-items: center;
	}
`;
